/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState } from "react";
import { FaMoneyBillAlt, FaMoneyBillWave, FaMoneyCheck, FaMoneyCheckAlt, FaRegMoneyBillAlt } from "react-icons/fa";

// api
import paymentApi from "../../api/Payment";

//css
import "../dashboard/Dashboard.css";

//components
import Card from "../../components/card/Card";
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import StatCard from "../../components/statcard/StatCard";

//data
import { empty, errorResponse, isObject, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import BoxLoading from "../../components/skeleton/BoxLoading";
import colors from "../../config/colors";
import DoughnutChart from "../../components/chart/doughnut/DoughnutChart";
import DonutChartLoading from "../../components/skeleton/DonutChartLoading";
import PaymentWrapper from "../../components/appWrapper/PaymentWrapper";
import LineChart from "../../components/chart/linechart/LineChart";
import { monthsArray } from "../../data/months";

const ActivitiesDashboard = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  // stat status
  const [isLoading, setIsLoading] =
    useState(false);
  const [paymentHistoryStats, setPaymentHistoryStats] = useState({});
  const [paymentSumPerMonth, setPaymentSumPerMonth] = useState({});

  const toastTR = useRef(null);

  useEffect(() => {
    getPaymentHistoryStats();
    getPaymentSumPerMonth();
  }, []);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  /**
   * Get Payment History stats
   * @returns 
   */
  const getPaymentHistoryStats = async () => {
     if (isLoading) setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await paymentApi.getPaymentHistoryStats(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Failed to fetch payment stats!"
            : "Failed to fetch payment stats"
        );
      }

      const data =
        isObject(response_data?.response)
          ? response_data.response
          : {};
      setPaymentHistoryStats(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get Payment sum per month
   * @returns 
   */
  const getPaymentSumPerMonth = async () => {
     if (isLoading) setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await paymentApi.getPaymentSumPerMonth(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Failed to fetch payment stats!"
            : "Failed to fetch payment stats"
        );
      }

      const data =
        isObject(response_data?.response)
          ? response_data.response
          : {};
      setPaymentSumPerMonth(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PaymentWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Payment Dashboard" />
          {/* end menu header */}
          <div
            className="mt-10 w-100pc"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            <div className="w-100pc">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Completed Payments"
                        entry={paymentHistoryStats?.completedPaymentCount || 0}
                        icon={
                          <FaMoneyCheck size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Cancelled Payments"
                        entry={paymentHistoryStats?.cancelledPaymentCount || 0}
                        icon={
                          <FaMoneyBillWave size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Pending Payments"
                        entry={paymentHistoryStats?.pendingPaymentCount || 0}
                        icon={
                          <FaRegMoneyBillAlt size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Completed Fees"
                        entry={paymentHistoryStats?.completedFeesCount || 0}
                        icon={
                          <FaMoneyCheckAlt size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="#Installment Fees"
                        entry={paymentHistoryStats?.inCompleteFeesCount || 0}
                        icon={
                          <FaMoneyBillAlt size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}

              <div className="inner_chart_box w-100pc">
                <Card
                  children={
                    <>
                      <MainHeader title="Fees Graph" />
                      {!isLoading ? (
                        <LineChart
                          labels={monthsArray}
                          data1={paymentSumPerMonth?.completedFeesArray || []}
                          data2={paymentSumPerMonth?.inCompleteFeesArray || []}
                          label1="Completed Fees"
                          label2="Installment Fees"
                          tag={user?.currency?.currency_symbol || ""}
                        />
                      ) : (
                        <DonutChartLoading />
                      )}
                    </>
                  }
                  addStyle="donut_chart_box line-chart"
                />
              </div>


              <div className="inner_chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Payments Chart" />
                      {!isLoading ? (
                        <DoughnutChart
                          doughnutData={[
                            paymentHistoryStats?.completedPaymentCount || 0,
                            paymentHistoryStats?.cancelledPaymentCount || 0,
                            paymentHistoryStats?.pendingPaymentCount || 0
                          ]}
                          label1="Complete"
                          label2="Cancelled"
                          label3="Pending"
                        />
                      ) : (
                        <DonutChartLoading />
                      )}
                    </>
                  }
                  addStyle="donut_chart_box fees"
                />
                <Card
                  children={
                    <>
                      <MainHeader title="Fees Chart" />
                      {!isLoading ? (
                        <DoughnutChart
                          doughnutData={[
                            paymentHistoryStats?.completedFeesCount || 0,
                            paymentHistoryStats?.inCompleteFeesCount || 0
                          ]}
                          label1="Completed"
                          label2="Installment"
                        />
                      ) : (
                        <DonutChartLoading />
                      )}
                    </>
                  }
                  addStyle="donut_chart_box fees"
                />
              </div>
            </div>
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </PaymentWrapper>
    </>
  );
};

export default ActivitiesDashboard;
